import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { startLoading, endLoading } from '../../../actions/loadingAction';
import { translate, formatData, showMessageToastCustom, isNullOrEmpty } from '../../../utils/util';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { ENUMS } from '../../../utils/constants';
import ChangeLocationService from '../../../services/ChangeLocationService';

const PrintConfirmationList = (props) => {
    const [receiptStorage, setReceiptStorage] = useState([]);

    useEffect(() => {
        if (props.physicalConfirmation.mvmNumber || props.physicalConfirmation.journey || (props.receiptIds && props.receiptIds.length > 0)) {
            props.getReceiptStorage(
                {
                    mvm: props.physicalConfirmation.mvmNumber,
                    journey: props.physicalConfirmation.journey,
                    receiptIds: props.receiptIds,
                    shed: props.filter?.truckKanban ? "" : props.user.shed,
                    dock: props.filter?.truckKanban ? "" : props.user.dock,
                    print: true,
                    truckKanban: props.filter?.truckKanban
                });
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.receiptStorage) {
            setReceiptStorage([...props.receiptStorage])
        }
        // eslint-disable-next-line
    }, [props.receiptStorage]);

    const sendPrinter = (row) => {
        if (navigator.userAgent !== 'logisticspwa' && props.user.printer?.connectionType === ENUMS.ePrinterConnectionType.Bluetooth.value) {
            showMessageToastCustom(translate('general:warning'), translate('validations:service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
        } else {

            if (!isNullOrEmpty(row.changeLocationId)) {
                props.sendToPrintLocation({
                    Id: row.changeLocationId,
                    printer: props.user.printer,
                });

            } else {
                props.showLoading();
                props.sendToPrint({
                    Id: row.receiptId,
                    transmissionId: row.transmissionId,
                    printer: props.user.printer,
                    OnlyOneLabel: true
                }, props.user);
            }
        }
    }

    return (
        <div>
            {
                receiptStorage.length > 0 && <ul key={receiptStorage.length} className="collection col s12" style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 0 }}>
                    {
                        receiptStorage.map((item, index) => {
                            return (
                                <div key={index} className="card" style={{ paddingTop: 0, margin: 0 }}>
                                    <div className="card-content" >
                                        <div className="row" >
                                            <div className="col s9 black-text">
                                                <span className="title col s12">{`${item?.partNumberCode}`}</span>
                                                <span className="col s12">{item?.partNumberDescription}</span>
                                                <div style={{ paddingLeft: '10px' }}>
                                                    <div className="col s5" style={{ padding: '0px' }}>
                                                        <small>{`${translate('parts', 'general')}: ${item?.quantity}`}</small></div>
                                                    <div className="col s5" style={{ padding: '0px' }}>
                                                        <small>{`${translate('physical-confirmation:qt-records')}: ${item?.quantity}`}</small>
                                                    </div>
                                                    <div className="col s8" style={{ padding: '0px' }}>
                                                        <small>{`${translate('physical-confirmation:almox')}: ${item?.almox || ''}`}</small>
                                                    </div>
                                                    <div className="col s8" style={{ padding: '0px' }}>
                                                        <small>{`${formatData(item?.printedOn) || ''}`}</small>
                                                    </div>
                                                    {
                                                        item?.changeLocationId &&
                                                        <div className="col s8" style={{ padding: '0px' }}>
                                                            <small style={{ color: 'orange' }}>Etiqueta Troca Locação (MDR Alternativo)</small>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col s3 center">
                                                <button
                                                    className="btn-floating btn-large btn-principal waves-effect waves-light"
                                                    type="button"
                                                    onClick={() => { sendPrinter(item) }}
                                                >
                                                    <i className="material-icons prefix">local_printshop</i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>)
                        })
                    }
                </ul>
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        physicalConfirmation: state.physicalConfirmationReducer.physicalConfirmation,
        receiptStorage: state.physicalConfirmationReducer.receiptStorage,
        receiptIds: state.physicalConfirmationReducer.receiptIds,
        filter: state.physicalConfirmationReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReceiptStorage: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getReceiptStorage(filter, callback));
        },
        sendToPrint: (item, user) => {
            dispatch(PhysicalConfirmationService.sendToPrintInstantConfirmation(item, user.printer, () => {
                dispatch(endLoading());
            }));
        },
        sendToPrintLocation: (data) => {
            dispatch(ChangeLocationService.reprintLabel(data));
        },
        showLoading: () => {
            dispatch(startLoading());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PrintConfirmationList));


